<template>
  <el-table-column
    :key="code"
    :label="name"
    :min-width="columnWidth"
    :fixed="false"
    align="center"
  >
    <template
      slot-scope="scope"
    >
      <!-- 编辑模式  -->
      <ik-table-check
        v-show="checkEdit(scope.$index, code, scope.row[code], scope.row)"
        :ref="'input_' + scope.$index + '_' + code"
        v-model="scope.row[code]"
        :line="scope.$index"
        :code="code"
        :name="name"
        :default-value="defaultValue"
        :key-field="keyField"
        :value-field="valueField"
        :options="options"
        :require="getRequire"
        @onFieldChange="onFieldChange"
      />
      <!-- 显示模式 -->
      <ik-table-check-tag
        v-show="!checkEdit(scope.$index, code, scope.row[code], scope.row)"
        :default-value="defaultValue"
        :value="scope.row[code]"
        :key-field="keyField"
        :value-field="valueField"
        :options="options"
      />
    </template>
  </el-table-column>
</template>

<script>
import IkTableCheck from '@/components/ik/table/input/IkTableCheck'
import IkTableCheckTag from '@/components/ik/table/input/IkTableCheckTag'
export default {
  name: 'IkColumnSelect',
  components: {
    IkTableCheck,
    IkTableCheckTag
  },
  model: {
    // 属性
    prop: 'value',
    // 事件
    event: 'input'
  },
  props: {
    code: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    line: {
      type: Number,
      default: 0
    },
    value: {
      type: String,
      default: ''
    },
    edit: {
      type: Boolean,
      default: true
    },
    columnWidth: {
      type: Number,
      default: 200
    },
    defaultValue: {
      type: String,
      default: ''
    },
    keyField: {
      type: String,
      default: ''
    },
    valueField: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: function() {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    require: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function() {
        return [
        ]
      }
    }
  },
  data() {
    return {
      errorSign: [],
      message: []
    }
  },
  computed: {
    getRequire() {
      return this.require
    }
  },
  methods: {
    checkEdit(line, code, value, row) {
      let reEdit = this.edit
      if (this.$listeners['checkEdit']) {
        // 如果提供执行
        this.$emit('checkEdit', line, code, value, row, val => {
          reEdit = val
        })
        return reEdit
      } else {
        // 否侧执行其他
        return reEdit
      }
    },
    onFieldChange(line, code, oldValue, value, errorSign, message) {
      this.$set(this.errorSign, line, errorSign)
      this.$set(this.message, line, message)
      this.$emit('onFieldChange', line, code, oldValue, value, errorSign, message)
    }
  }
}
</script>
<style scoped>
::v-deep.require> .el-input__inner{
    border: red 1px solid;
}
</style>
<style lang="scss" >
.el-form-item {
  margin-bottom: 12px;
  width: 100%;
}
.el-form-item__label {
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-form-item__content {
  width: calc(100% - 180px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
